/* rv-i18n-localize : couche suédoise (sv) et néerlandaise (nl) des marchés Suède / Pays-Bas.
   Dérivé du moteur arabe rv-ar-localize (21/09/2026), sans RTL. Chargé uniquement quand la langue
   de la page est « sv » ou « nl ». Traduit le texte écrit en dur
   dans les sections (ce que les traductions Shopify ne couvrent pas) par correspondance
   EXACTE d'unités de texte, jamais par regex sur des fragments de mots.
   Une unité = un élément dont tous les enfants sont du texte ou des éléments en ligne.
   Les éléments en ligne sont codés [[n]]…[[/n]], les éléments atomiques (br, img, svg) [[n/]]. */
(function () {
  'use strict';
  var W = window, D = document;
  var CFG = W.RVI_CFG || {};
  var DICT = W.RVI_DICT = W.RVI_DICT || {};
  var PATTERNS = W.RVI_PATTERNS || [];
  var COLLECT = !!CFG.collect;
  var MISSING = W.RVI_MISSING = W.RVI_MISSING || {};
  var COUNTRY = CFG.country || '';

  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, CODE: 1, PRE: 1, TEMPLATE: 1, IFRAME: 1, SELECT: 1, svg: 1, SVG: 1, CANVAS: 1, VIDEO: 1, AUDIO: 1 };
  var INLINE = { A: 1, ABBR: 1, B: 1, BDI: 1, BDO: 1, BR: 1, CITE: 1, DEL: 1, DFN: 1, EM: 1, FONT: 1, I: 1, IMG: 1, INS: 1, KBD: 1, MARK: 1, Q: 1, S: 1, SMALL: 1, SPAN: 1, STRONG: 1, SUB: 1, SUP: 1, TIME: 1, U: 1, WBR: 1, svg: 1, SVG: 1 };
  var ATOMIC = { BR: 1, IMG: 1, WBR: 1, svg: 1, SVG: 1 };
  var LATIN = /[A-Za-z]{2}/;
  var MARK = /\[\[\/?\d+\/?\]\]/g;
  var MONEY = /£\s?\d[\d,]*(?:\.\d+)?|€\s?\d{1,3}(?:[.\u00a0\u202f ]?\d{3})*(?:,\d{1,2})?|\d{1,3}(?:[\u00a0\u202f ]\d{3})*(?:,\d{1,2})?\s?kr\b|\d{1,3}(?:\.\d{3})+(?:,\d{1,2})?\s?kr\.?|kr\.\s?\d{1,3}(?:\.\d{3})*(?:,\d{1,2})?|SEK\s?\d[\d\u00a0\u202f ]*(?:,\d{1,2})?|DKK\s?\d[\d.]*(?:,\d{1,2})?/g;
  function arMoney(x) {
    if (!/£/.test(x) || !CFG.rate) return x;
    var v = parseFloat(x.replace(/[^\d.]/g, '')); if (isNaN(v)) return x;
    var n = v * CFG.rate;
    if (CFG.cur === 'DKK') { n = v === 0 ? 0 : n >= 20 ? Math.max(19, Math.round(n / 10) * 10 - 1) : Math.round(n); return n.toLocaleString('da-DK') + ' kr.'; }
    if (CFG.cur === 'NOK') { n = v === 0 ? 0 : n >= 20 ? Math.max(19, Math.round(n / 10) * 10 - 1) : Math.round(n); return n.toLocaleString('nb-NO').replace(/[\u00a0\u202f]/g, ' ') + ' kr'; }
    if (CFG.cur === 'SEK') { n = v === 0 ? 0 : n >= 20 ? Math.max(19, Math.round(n / 10) * 10 - 1) : Math.round(n); return n.toLocaleString('sv-SE').replace(/\u00a0/g, ' ') + ' kr'; }
    n = v === 0 ? 0 : n >= 5 ? Math.round(n) - 0.1 : Math.round(n * 10) / 10;
    return '€' + n.toFixed(n % 1 ? 2 : 0).replace('.', ',');
  }

  /* Badge de remise isolé (« 50% OFF », « -30% », « SAVE 20% ») : jamais affiché sur ces marchés. */
  var PROMO = /^(?:[-−–]\s?\d{1,2}\s?%|\d{1,2}\s?%\s?(?:OFF|off|Off)|(?:SAVE|Save|save)\s\d{1,2}\s?%|(?:OFF|off)\s\d{1,2}\s?%)(?:\s*[!✨🔥])?$/;
  function norm(s) { return s.replace(/[\s ​‎‏]+/g, ' ').trim(); }
  function skipEl(el) {
    return SKIP[el.nodeName] || (el.hasAttribute && (el.hasAttribute('data-rvi-skip') || el.isContentEditable));
  }
  function inlineOnly(el) {
    for (var c = el.firstChild; c; c = c.nextSibling) {
      if (c.nodeType === 1) {
        if (!INLINE[c.nodeName]) return false;
        if (!ATOMIC[c.nodeName] && !inlineOnly(c)) return false;
      }
    }
    return true;
  }
  function serialize(el, ctx) {
    var out = '';
    for (var c = el.firstChild; c; c = c.nextSibling) {
      if (c.nodeType === 3) out += c.nodeValue;
      else if (c.nodeType === 1) {
        var n = ++ctx.n; ctx.nodes[n] = c;
        if (ATOMIC[c.nodeName]) out += '[[' + n + '/]]';
        else out += '[[' + n + ']]' + serialize(c, ctx) + '[[/' + n + ']]';
      }
    }
    return out;
  }
  /* Clé normalisée : espaces repliés, pictos de tête/queue retirés, montants remplacés par {M}. */
  function keyOf(el) {
    var ctx = { n: 0, nodes: {} };
    var raw = norm(serialize(el, ctx));
    var lead = [], trail = [], m;
    while ((m = /^\[\[(\d+)\/\]\]\s*/.exec(raw))) { lead.push(+m[1]); raw = raw.slice(m[0].length); }
    while ((m = /\s*\[\[(\d+)\/\]\]$/.exec(raw))) { trail.unshift(+m[1]); raw = raw.slice(0, raw.length - m[0].length); }
    var money = [];
    raw = raw.replace(MONEY, function (x) { money.push(x); return '{M}'; });
    return { key: raw, ctx: ctx, lead: lead, trail: trail, money: money };
  }
  function lookup(key) {
    var v = DICT[key];
    if (v === undefined) {
      var nums = [], k2 = key.replace(/(^|[^\w.\[\/])(\d+(?:[.,]\d+)?)(?![\w\]])/g, function (a, p, d) { nums.push(d); return p + '{N}'; });
      if (nums.length && DICT[k2] !== undefined) {
        var i = 0; v = DICT[k2].replace(/\{N\}/g, function () { return nums[i++] || ''; });
      }
    }
    if (v === undefined) {
      for (var p = 0; p < PATTERNS.length; p++) {
        var re = PATTERNS[p][0];
        if (re.test(key)) { v = key.replace(re, PATTERNS[p][1]); re.lastIndex = 0; break; }
      }
    }
    if (v !== undefined && COUNTRY) v = v.replace(/\{COUNTRY\}/g, COUNTRY);
    return v;
  }
  function fillMoney(v, money) {
    var i = 0;
    return v.replace(/\{M\}/g, function () { var x = money[i++]; return x === undefined ? '' : arMoney(x); });
  }
  /* Nœud texte qui ne contient qu'un ou plusieurs montants (« 549.00 SR ») : devise en arabe. */
  function moneyOnly(t) {
    var raw = t.nodeValue;
    if (!raw || raw.indexOf('£') < 0) return false;
    MONEY.lastIndex = 0;
    if (raw.replace(MONEY, '').trim()) return false;
    t.nodeValue = raw.replace(MONEY, function (x) { return arMoney(x); });
    return true;
  }
  function note(key) {
    if (LATIN.test(key.replace(MARK, '').replace(/\{[MN]\}/g, ''))) MISSING[key] = (MISSING[key] || 0) + 1;
  }
  function hide(el) { el.style.setProperty('display', 'none', 'important'); el.__rviOut = '__DROP__'; }

  function rebuild(el, info, value) {
    var ctx = info.ctx, stack = [D.createDocumentFragment()], re = /\[\[(\/?)(\d+)(\/?)\]\]/g, last = 0, m, used = {}, emptied = [];
    function text(t) { if (t) stack[stack.length - 1].appendChild(D.createTextNode(t)); }
    while ((m = re.exec(value))) {
      text(value.slice(last, m.index)); last = re.lastIndex;
      var node = ctx.nodes[+m[2]];
      if (!node) continue;
      if (m[3]) { stack[stack.length - 1].appendChild(node); used[m[2]] = 1; }
      else if (!m[1]) {
        if (node.textContent.trim()) emptied.push(node);
        while (node.firstChild) node.removeChild(node.firstChild);
        stack[stack.length - 1].appendChild(node); stack.push(node); used[m[2]] = 1;
      }
      else if (stack.length > 1) stack.pop();
    }
    text(value.slice(last));
    var frag = stack[0];
    var leadNodes = info.lead.map(function (n) { return ctx.nodes[n]; });
    var trailNodes = info.trail.map(function (n) { return ctx.nodes[n]; });
    while (el.firstChild) el.removeChild(el.firstChild);
    leadNodes.forEach(function (n) { el.appendChild(n); el.appendChild(D.createTextNode(' ')); });
    el.appendChild(frag);
    trailNodes.forEach(function (n) { el.appendChild(D.createTextNode(' ')); el.appendChild(n); });
    // un badge dont le texte a été retiré (promo) ne doit pas rester comme pastille vide
    emptied.forEach(function (n) { if (!n.textContent.trim() && !n.querySelector('img,svg')) n.style.setProperty('display', 'none', 'important'); });
  }

  function doUnit(el) {
    if (el.__rviOut === '__DROP__') return;
    var info = keyOf(el);
    if (!info.key || info.key === el.__rviOut) return;
    // enveloppe unique <span>texte</span> : on descend dans l'enfant
    var w = /^\[\[(\d+)\]\]([\s\S]*)\[\[\/\1\]\]$/.exec(info.key);
    if (w && !info.lead.length && !info.trail.length && w[2].indexOf('[[' + w[1] + ']]') < 0) {
      var child = info.ctx.nodes[+w[1]];
      if (child) { doUnit(child); return; }
    }
    if (!LATIN.test(info.key.replace(MARK, ''))) return;
    if (COLLECT) { note(info.key); return; }
    var v = lookup(info.key);
    if (v === undefined) {
      note(info.key);
      // repli : phrase entière inconnue → on tente chaque morceau (badge, libellé, montant)
      if (info.key.indexOf('[[') > -1) {
        for (var c2 = el.firstChild; c2; c2 = c2.nextSibling) {
          if (c2.nodeType === 3) doText(c2);
          else if (c2.nodeType === 1 && !ATOMIC[c2.nodeName]) doUnit(c2);
        }
      }
      el.__rviOut = info.key;
      return;
    }
    if (v === '__DROP__') { hide(el); return; }
    v = fillMoney(v, info.money);
    if (info.key.indexOf('[[') < 0 && !info.lead.length && !info.trail.length && el.childNodes.length === 1 && el.firstChild.nodeType === 3) {
      el.firstChild.nodeValue = v;
    } else {
      rebuild(el, info, v);
    }
    el.__rviOut = keyOf(el).key;
  }
  function doText(t) {
    if (!COLLECT && moneyOnly(t)) return;
    var raw = t.nodeValue, key = norm(raw);
    if (!key || key === t.__rviOut || !LATIN.test(key)) return;
    var money = []; key = key.replace(MONEY, function (x) { money.push(x); return '{M}'; });
    if (COLLECT) { note(key); return; }
    var v = lookup(key);
    if (v === undefined) { note(key); return; }
    if (v === '__DROP__') v = '';
    v = fillMoney(v, money);
    t.nodeValue = (/^\s/.test(raw) ? ' ' : '') + v + (/\s$/.test(raw) ? ' ' : '');
    t.__rviOut = norm(t.nodeValue);
  }
  /* Images : version arabe d'un visuel à texte, repérée par NOM DE FICHIER Shopify
     (window.RVAR_IMG = {"nom.jpg": "//therelievoo.com/cdn/shop/files/nom-ar.jpg"}).
     Les paramètres de redimensionnement (width, height, crop) sont conservés. */
  var IMG = W.RVI_IMG || {};
  function imgName(u) { var m = /\/([^\/?#]+)(?:\?|#|$)/.exec(u || ''); return m ? decodeURIComponent(m[1]) : ''; }
  function swapUrl(u) {
    if (!u || (u.indexOf('/cdn/shop/') < 0 && u.indexOf('cdn.shopify.com/s/files/') < 0)) return null;
    var n = imgName(u), t = IMG[n];
    if (!t) return null;
    var q = u.indexOf('?') > -1 ? u.slice(u.indexOf('?') + 1).split('&').filter(function (p) { return !/^v=/.test(p); }).join('&') : '';
    return t + (q ? (t.indexOf('?') > -1 ? '&' : '?') + q : '');
  }
  function doImg(el) {
    var s = el.getAttribute('src'), r = swapUrl(s), hit = false;
    if (r) { el.setAttribute('src', r); hit = true; }
    ['srcset', 'data-srcset'].forEach(function (a) {
      var ss = el.getAttribute(a);
      if (!ss) return;
      var nss = ss.split(',').map(function (part) {
        var p = part.trim().split(/\s+/), nu = swapUrl(p[0]);
        if (nu) { hit = true; p[0] = nu; }
        return p.join(' ');
      }).join(', ');
      if (nss !== ss) el.setAttribute(a, nss);
    });
    var st = el.getAttribute('style');
    if (st && st.indexOf('url(') > -1) {
      var nst = st.replace(/url\((['"]?)([^'")]+)\1\)/g, function (all, q, u) { var nu = swapUrl(u); if (nu) { hit = true; return 'url(' + q + nu + q + ')'; } return all; });
      if (nst !== st) el.setAttribute('style', nst);
    }
    if (hit) el.__rviImg = 1;
  }
  var ATTRS = ['placeholder', 'title', 'aria-label', 'alt', 'data-placeholder'];
  function doAttrs(el) {
    for (var i = 0; i < ATTRS.length; i++) {
      var a = el.getAttribute(ATTRS[i]);
      if (!a || !LATIN.test(a)) continue;
      var k = norm(a);
      if (el['__rviA' + i] === k) continue;
      if (ATTRS[i] === 'alt') continue;
      if (COLLECT) { note(k); continue; }
      var v = lookup(k);
      if (v === undefined) { if (ATTRS[i] !== 'alt') note(k); continue; }
      if (v === '__DROP__') v = '';
      el.setAttribute(ATTRS[i], v); el['__rviA' + i] = v;
    }
    if (el.nodeName === 'INPUT' && /^(submit|button)$/i.test(el.type) && el.value && LATIN.test(el.value)) {
      var vv = lookup(norm(el.value)); if (vv !== undefined && vv !== '__DROP__') el.value = vv; else if (vv === undefined) note(norm(el.value));
    }
  }
  function scan(node) {
    if (node.nodeType === 3) { doText(node); return; }
    if (node.nodeType !== 1) return;
    if (node.nodeName === 'IMG' || node.nodeName === 'SOURCE' || (node.hasAttribute && node.hasAttribute('style'))) doImg(node);
    if (node.querySelectorAll && (node.nodeName === 'PICTURE' || node.nodeName === 'NOSCRIPT' || skipEl(node))) {
      var inner = node.querySelectorAll('img,source'); for (var k = 0; k < inner.length; k++) doImg(inner[k]);
    }
    if (skipEl(node)) return;
    if (node.attributes && node.attributes.length) doAttrs(node);
    if (node.firstChild && inlineOnly(node) && node.nodeName !== 'BODY' && node.nodeName !== 'HTML') {
      var hasText = false;
      for (var c = node.firstChild; c; c = c.nextSibling) if (c.nodeType === 3 && c.nodeValue.trim()) { hasText = true; break; }
      if (hasText || node.querySelector('*')) {
        doUnit(node);
        var imgs = node.querySelectorAll('[alt],[title],[aria-label]');
        for (var j = 0; j < imgs.length; j++) doAttrs(imgs[j]);
        var pics = node.querySelectorAll('img,source,[style*="url("]');
        for (var j2 = 0; j2 < pics.length; j2++) doImg(pics[j2]);
        return;
      }
    }
    for (var ch = node.firstChild; ch; ch = ch.nextSibling) scan(ch);
  }
  /* Remonte à l'unité englobante d'un nœud modifié (parent non « en ligne »). */
  function rescan(node) {
    var p = node.nodeType === 1 ? node : node.parentNode;
    while (p && p.nodeType === 1 && INLINE[p.nodeName] && p.parentNode && p.parentNode.nodeType === 1) p = p.parentNode;
    if (!p || p.nodeType !== 1) return;
    for (var q = p; q; q = q.parentNode) if (q.nodeType === 1 && skipEl(q)) return;
    scan(p);
  }
  var queue = [], scheduled = false;
  function flush() {
    scheduled = false;
    var list = queue; queue = [];
    for (var i = 0; i < list.length; i++) if (list[i].isConnected) rescan(list[i]);
  }
  var mo = new MutationObserver(function (recs) {
    for (var i = 0; i < recs.length; i++) {
      var r = recs[i];
      if (r.type === 'characterData') queue.push(r.target);
      else if (r.type === 'attributes') { if (r.target.nodeType === 1) { if (/^(src|srcset|data-srcset|style)$/.test(r.attributeName)) doImg(r.target); else doAttrs(r.target); } }
      else for (var j = 0; j < r.addedNodes.length; j++) queue.push(r.addedNodes[j]);
    }
    if (!scheduled) { scheduled = true; flush(); }
  });
  mo.observe(D, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS.concat(['src', 'srcset', 'data-srcset', 'style']) });

  function uncloak() { if (D.documentElement) D.documentElement.classList.remove('rvi-cloak'); }
  function full() {
    if (D.body) scan(D.body);
    var t = norm(D.title || '');
    if (t && LATIN.test(t) && !COLLECT) { var v = lookup(t); if (v && v !== '__DROP__') D.title = v; }
    uncloak();
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', full); else full();
  W.addEventListener('load', function () { if (D.body) scan(D.body); });
  setTimeout(uncloak, 1000);
  W.RVI = { scan: scan, lookup: lookup, keyOf: keyOf };
})();
